<template>
  <div id="numberbaseset">
	<div>
		<el-select @change="getList" size="small" v-model="search.type">
		  <el-option :label="lg.all" value="0">{{lg.all}}</el-option>
		  <el-option :label="lg.layer" value="1">{{lg.layer}}</el-option>
		  <el-option :label="lg.deep" value="2">{{lg.deep}}</el-option>
		</el-select>
		<el-select @change="getList" size="small" v-model="search.status" style="margin-left: 10px;">
		  <el-option :label="lg.all" value="0">{{lg.all}}</el-option>
		  <el-option :label="lg.had" value="1">{{lg.had}}</el-option>
		  <el-option :label="lg.will" value="2">{{lg.will}}</el-option>
		</el-select>
		<el-button class="btn_blue_boder" @click="resetDefault(0)" size="small" style="margin-left: 10px;">{{lg.reset_selected}}</el-button>
		<el-button class="btn_blue_boder" @click="alertEdit(0)" size="small">{{lg.edit_selected}}</el-button>
		<el-button class="btn_gray" @click="getList" size="small" style="float: right;">{{lg.sure}}</el-button>
		<el-input size="small" v-model="search.str" style="float: right;width: 200px;"></el-input>
	</div>
    <div class="deviceAddBlock">
      <el-table :data="lists" style="width: 100%" ref="multipleTable" @selection-change="getSelectOption">
		<el-table-column type="selection" width="55"></el-table-column>
		<el-table-column prop="number" :label="lg.tablefiled[0]"></el-table-column>
        <el-table-column prop="name" :label="lg.tablefiled[1]"></el-table-column>
        <el-table-column prop="ratename" :label="lg.tablefiled[2]"></el-table-column>
        <el-table-column prop="mod_time" :label="lg.tablefiled[3]"></el-table-column>
        <el-table-column :label="$i18n.t('contral')">
          <template slot-scope="scope">
			<el-button @click="resetDefault(scope.row)" class="btn1" type="primary" size="mini">{{lg.reset}}</el-button>
            <el-button @click="alertEdit(scope.row)" class="btn1" type="primary" size="mini">{{$t("edit")}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog width="30%" :title="lg.title" :visible.sync="dialogFormVisible">
	  <div style="color: #000000;font-size: 24px;width: 100%;height: auto;line-height: 40px;text-align: center;">{{editOption}}</div>
      <el-form class="editsetting">
        <el-form-item :label-width="formLabelWidth">
          <el-slider :min="-50" :max="50" height="20px" v-model="editValue" show-input></el-slider>
		  <span class="minu">{{lg.minuscore}}</span>
		  <span class="plus">{{lg.addscore}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn_blue_boder" size="small" @click="dialogFormVisible = false">{{lg.cancle}}</el-button>
        <el-button class="btn_blue_boder" size="small" @click="goSubmit" type="primary">{{lg.save}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'numberbaseset',
  data () {
    return {
	  lg: this.$i18n.t("config_numberbaseset"),
      doing: false,
      search:{
        str: '',
        type: '0',
		status: '0'
      },
      lists: null,
	  allData: null,
	  selectedData: null,
      dialogFormVisible: false,
	  editOption: '',
	  editValue: 0,
	  editData:{},
      formLabelWidth: '0.1rem'
    }
  },
  computed: {
  },
  created () {
	if(localStorage.locale !== 'zh'){
		this.formLabelWidth = '1.6rem'
	}
    this.initList()
  },
  methods: {
	getSelectOption (val) {
	  this.selectedData = null
	  if(val){
		this.selectedData = val
	  }
    },
    resetDefault (item) {
		let arr = {}
		if(item != 0){
			arr[item.typename] = 0
		}else{
			for(let i in this.selectedData){
				arr[this.selectedData[i].typename] = 0
			}
		}
		arr.customer_id = -1
		this.setSetting(arr)
    },
	getList(){
		sessionStorage.searchForSetting = JSON.stringify(this.search)
		let arr = new Array()
		for(let i in this.allData){
			if(this.search.type == 1 && this.allData[i].categray == 'deep'){ //表层不符合
				continue
			}
			if(this.search.type == 2 && this.allData[i].categray == 'layer'){ //深层不符合
				continue
			}
			if(this.search.status == 1 && !this.allData[i].id){ //已检测不符合
				continue
			}
			if(this.search.status == 2 && this.allData[i].id){ //未测不符合
				continue
			}
			if(this.search.str && this.allData[i].name.indexOf(this.search.str) == -1 && this.allData[i].typename.indexOf(this.search.str) == -1){ //搜索不符合
				continue
			}
			arr.push(this.allData[i])
		}
		this.lists = arr
		this.dialogFormVisible = false
	},
    initList () {
      if (this.doing === true) {
        return false
      }
      this.doing = true
      let _this = this
      let data = this.search
      this.axios.get('/skinMgrSrv/settings/get', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.lists = response.data.list
		  _this.allData = response.data.list
		  if(sessionStorage.searchForSetting){
			_this.search = JSON.parse(sessionStorage.searchForSetting)
			_this.getList()
		  }
		  _this.dialogFormVisible = false
        }
      })
    },
	setSetting (data) {
	  if (this.doing === true) {
	    return false
	  }
	  this.doing = true
	  let _this = this
	  this.axios.post('/skinMgrSrv/settings/update', this.formData(data)).then(function (response) {
	    _this.doing = false
	    if (response.data.code === 0) {
	      _this.initList()
	    }
	  })
	},
    alertEdit (data) {
	  this.editOption = ''
	  this.editData = {}
      if(data != 0){
		this.editOption = data.name
		this.editValue = parseInt(data.rate)
		this.$set(this.editData,data.typename, data.rate)
	  }else{
		console.log(this.selectedData)
		if(!this.selectedData){
			this.$message(this.lg.tips_selected)
			return false
		}
		for(let i in this.selectedData){
			if(i != 0){
				this.editOption += ','
			}
			this.editOption += this.selectedData[i].name
			this.editValue = 0
			this.$set(this.editData,this.selectedData[i].typename, 0)
		}
	  }
	  this.dialogFormVisible = true
    },
	goSubmit(){
		for(let i in this.editData){
			this.$set(this.editData, i, this.editValue)
		}
		this.$set(this.editData, 'customer_id', -1)
		this.setSetting(this.editData)
	}
  }
}
</script>
<style  lang="scss">
  #numberbaseset{
    .tabs-container {
      .el-card__header {
        padding: 0.0833rem 0.1667rem !important;
      }
      .el-card{
        cursor: pointer;
      }
      .el-card:hover{
        border: $blue 1px solid;
      }
    }
    .el-dialog__header{
      border-bottom: #E9E9E9 1px solid !important;
    }
    .el-button--primary {
      color: #fff;
      background-color: #57AEC9;
      border-color: #57AEC9;
    }
	.el-dialog__body{
		padding-bottom: 10px;
	}
	.editsetting{
		.el-slider__input {
		    float: none;
		    margin-top: 10px;
		    margin-left: calc(50% - 75px);
		    display: block;
			margin-bottom: 30px;
		}
		.el-input-number__increase,.el-input-number__decrease {
		    top: 2px;
		}
		.el-slider__runway.show-input {
		    margin-right: 0;
		    width: 100%;
		}
		.el-slider__bar {
		    background-color: #57AEC9;
			height: 20px;
			border-radius: 10px;
		}
		.el-slider__runway {
		    width: 100%;
		    height: 20px;
		    margin: 16px 0;
		    background-color: #DE7676;
		    border-radius: 10px;
		    position: relative;
		    cursor: pointer;
		    vertical-align: middle;
		}
		.el-slider__button {
			width: 30px;
			height: 30px;
			background: #FFFFFF;
			border-radius: 15px;
			border: 1px solid #D9D9D9;
			margin-top: 8px;
		}
	}
	.minu{
		float: left;
		margin-top: -10px;
	}
	.plus{
		float: right;
		margin-top: -10px;
	}
  }

</style>

<style scoped lang="scss">
  #numberbaseset {
    padding: 0.266rem;
    box-sizing: border-box;
    background-color: #fff;
    margin: 0.166rem;
    p.title{
      height: 0.4167rem;
      line-height:0.4167rem;
      font-size:0.15rem;
      color:#000;
    }
    .btn2,.btn3{
      padding: 0.0667rem 0.0833rem;
    }
    .codeshearch{
      width: 1.667rem;
    }
    .btn3,.codeshearch{
      float: right;
    }
    .deviceAddBlock{
      margin-top: 0.16rem;
      background-color: #fff;
      border-radius: 0.04166rem;
      padding: 0.0833rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/config/numberbaseset.vue